import React, { Component, ErrorInfo, ReactNode } from 'react';
import showConsole from '@/utils/showConsole';

interface RouterErrorBoundaryProps {
  children: ReactNode;
  fallback?: ReactNode;
}

interface RouterErrorBoundaryState {
  hasError: boolean;
  error?: Error;
}

class RouterErrorBoundary extends Component<RouterErrorBoundaryProps, RouterErrorBoundaryState> {
  constructor(props: RouterErrorBoundaryProps) {
    super(props);
    this.state = { hasError: false };
  }

  static getDerivedStateFromError(error: Error): RouterErrorBoundaryState {
    // Check if this is a router context error
    if (error.message.includes('basename') || 
        error.message.includes('useContext') || 
        error.message.includes('Router') ||
        error.message.includes('Navigation')) {
      return { hasError: true, error };
    }
    // Let other errors bubble up
    throw error;
  }

  componentDidCatch(error: Error, errorInfo: ErrorInfo): void {
    console.warn('Router context error caught:', error.message);
    // Don't log the full error in production to avoid console spam
    // if (process.env.NODE_ENV === 'development') {
    if (showConsole) {
      console.error('Router Error Details:', error, errorInfo);
    }
  }

  render() {
    if (this.state.hasError) {
      // Return the fallback or a simple div to prevent crashes
      return this.props.fallback || <div className="hidden" />;
    }

    return this.props.children;
  }
}

export default RouterErrorBoundary;
